import Register from "./Register";

export default Register;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/authentication/Register/index.tsx